import React, { useEffect, useState } from "react";
import ProductList from "../../components/DynamicList&Grid/DynamicListGrid";
import { getStoredData } from "../../json/fecthData";
import { useApiData } from "../../components/ApiDataProvider/ApiDataProvider";

const RoleManagement = () => {
  const roleData = getStoredData()?.[1] || {}; // Extract role-related data (assuming it's at index 2)

  const { TitleRole, AdminRole, RedirectAdminRole, ApiRole } = roleData;

  const { apiData, loading, error } = useApiData(["roles"]); // Fetch role data from API
  const [roles, setRoles] = useState([]); // Initialize state for roles

  useEffect(() => {
    if (apiData?.roles && Array.isArray(apiData.roles)) {
      setRoles(apiData.roles); // Ensure roles is always an array
    } else {
      setRoles([]); // Fallback to empty array
    }
  }, [apiData]);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

  return (
    <div className="RoleManagement">
      <h1>{TitleRole} Management</h1>

      {AdminRole && roles.length > 0 ? (
        <ProductList
          products={roles} // Pass role data dynamically from API
          fields={AdminRole} // Pass fields dynamically from configuration
          redirect={RedirectAdminRole} // Use redirect path for editing role
          deleteApi={ApiRole} // API endpoint for deletion
          showEdit={true} // Enable edit button
          showDelete={true} // Enable delete button
          createPath={`/${TitleRole?.toLowerCase()}/create`} // Dynamically generate create path
        />
      ) : (
        <p>No data available</p>
      )}
    </div>
  );
};

export default RoleManagement;
